<template>
  <div class="diadin">
    <div style="display: flex;width: 400px;margin-bottom: 20px;">
      <el-input clearable  :placeholder="$t('menu.khjca')"  v-model="dealerNameFull"
           ></el-input>
            <el-button  style="margin-left: 20px;" type="primary" @click="biao">{{ $t('menu.sousuo') }}</el-button>
    </div>
    <el-button type="primary" style="margin-bottom: 20px" @click="handleEdit(1)">{{ $t('menu.AddAccount') }}</el-button>
    <el-table  empty-text=" " :data="mation" style="width: 100%" stripe border highlight-current-row>
       <el-table-column prop="dealerName" :label="$t('menu.khjc')"></el-table-column>
      <el-table-column prop="dealerNameFull" :label="$t('menu.lssjxsmc')"></el-table-column>
      <el-table-column prop="loginEmail" :label="$t('menu.lssyx')"> </el-table-column>
      <!-- <el-table-column prop="loginMobile" label="登录手机号"> </el-table-column> -->
      <el-table-column prop="status">
        <template slot="header" slot-scope="scope">
          <div>{{$t('menu.lsszt')}}</div>
        </template>
        <template slot-scope="scope">
          <div v-if=" scope.row.status==0">
            {{$t('menu.hezuozong')}}
          </div>   
          <div v-if=" scope.row.status==1">
            {{$t('menu.yizhjongzh')}}
          </div>  
        </template>
      </el-table-column>

      <el-table-column>
        <template slot="header" slot-scope="scope">
          <div>{{ $t('menu.Operation') }}</div>
        </template>

        <template slot-scope="scope">
          <el-button type="text" size="mini"  @click="handleEdit(2, scope.row)" style="font-weight: 400;">{{
            $t('menu.Edit') }}</el-button>
          <el-button type="text" size="mini" @click="handleEdit(4, scope.row)" style="font-weight: 400;">{{
            $t('menu.ChangePassword') }}</el-button>
          <el-button type="text" size="mini"  @click="handleEdit(3, scope.row)" style="font-weight: 400;">{{
            $t('menu.Delete') }}</el-button>
             <el-button type="text" size="mini"  @click="login( scope.row)" style="font-weight: 400;">{{ $t('menu.kuaijiedenglul') }}</el-button>
              <el-button type="text" size="mini" v-if="scope.row.erpOpen=='1'"  @click="hace( scope.row.id)" style="font-weight: 400;">{{  $t('menu.lsserp') }}</el-button>

        </template>
      </el-table-column>
    </el-table>
    <div class="bottompage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage3"
        :page-sizes="[10, 20, 50, 100]" :page-size="10" layout="total, prev, pager, next" :total="totale">
      </el-pagination>
    </div>
    <el-dialog :title="titleaa" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
      <div class="ccca" style=" margin: 0 auto">
        <el-form ref="formInline" :model="formInline" label-width="160px">
          <el-form-item :label="$t('menu.lingshousjianc')" required v-if="titleaa !== $t('menu.ChangePassword')">
          </el-form-item>
          <el-input  :disabled="doingtype == 2" v-if="titleaa !== $t('menu.ChangePassword')" v-model="formInline.dealerName"
           ></el-input>
             <el-form-item required :label="$t('menu.lingshousquanc')" v-if="titleaa !== $t('menu.ChangePassword')">
          </el-form-item>
          <el-input v-if="titleaa !== $t('menu.ChangePassword')" v-model="formInline.dealerNameFull"
           ></el-input>
          <el-form-item required :label="$t('menu.EmailAddress')" v-if="titleaa !== $t('menu.ChangePassword')">
          </el-form-item>
          <el-input v-if="titleaa !== $t('menu.ChangePassword')" v-model="formInline.loginEmail"
            :disabled="doingtype == 2"></el-input>
            <!-- <el-form-item label="登录手机号" required v-if="titleaa !== $t('menu.ChangePassword')">
          </el-form-item>
          <el-input v-if="titleaa !== $t('menu.ChangePassword')" v-model="formInline.loginMobile"
            :disabled="doingtype == 2"></el-input> -->
            
          <el-form-item required :label="$t('menu.Password')" v-if="doingtype !== 2">
            <!-- <template slot="label" >
              <div>{{ $t('menu.Password')}} </div>
            </template> -->
          </el-form-item>
          <el-input v-if="doingtype != 2 && titleaa !== $t('menu.ChangePassword')"
            v-model="formInline.loginPassword"></el-input>
          <el-input v-if="doingtype != 2 && titleaa == $t('menu.ChangePassword')" v-model="oldPassworda"></el-input>

          <el-form-item required :label="$t('menu.hezuozhuangt')" style="margin-top: 10px;"
            v-if="titleaa !== $t('menu.ChangePassword')">
            <!-- <template slot="label" >
              <div>{{ $t('menu.Role') }}</div>
            </template> -->
          </el-form-item>
          <el-select v-if="titleaa !== $t('menu.ChangePassword')" v-model="formInline.status"
            :placeholder="$t('menu.hezuozhuangt')">
            <el-option  :label="$t('menu.hezuozong')" :value="0"></el-option> 
             <el-option  :label="$t('menu.yizhjongzh')" :value="1"></el-option>
          </el-select>
          
        </el-form>
        <div style=" margin: 30px auto" class="er">
          <el-button v-if="doingtype == 1 || titleaa == $t('menu.ChangePassword')" type="primary" @click="updata"
            class="er">{{ $t('menu.Confirm') }}</el-button>
          <el-button v-if="doingtype == 2" type="primary" @click="putdata" class="er">{{ $t('menu.Confirm')
            }}</el-button>

        </div>
      </div>
    </el-dialog>

    <el-dialog :title="$t('menu.DeleteAccount')" :visible.sync="delType" width="20%">
      <div style="display: flex; justify-content: center;">
        {{ $t('menu.DelAc') }}
      </div>
      <div style="margin-top: 30px;display: flex; justify-content: center;">
        <el-button type="primary" @click="deleteU" style="width: 130px;">{{ $t('menu.Confirm') }}</el-button>
      </div>
    </el-dialog>
      <el-dialog title="ERP账号绑定" :visible.sync="erp" width="50%">
      <el-form :inline="true" :model="erpform" class="demo-form-inline">
        <el-form-item label="">
          <el-input v-model="erpform.erpCode" placeholder="零售商ERP编码"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="erpform.erpCompany" placeholder="零售商ERP名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSuerp">添加</el-button>
        </el-form-item>
      </el-form>
         <div>
          <el-table :data="erplist" style="width: 100%">
           <el-table-column
              prop="erpCode"
              label="零售商ERP编码"
              >
            </el-table-column>
            <el-table-column
              prop="erpCompany"
              label="零售商ERP名称"
             >
            </el-table-column>
            <el-table-column
              prop="status"
              label="状态"
             >
             <template slot-scope="scope">
              <el-switch
    v-model="scope.row.status"
    @change="binha($event,scope.row.id)"
    active-color="#13ce66"
    inactive-color="#ff4949"
    active-value="1"
    inactive-value="0">
     </el-switch>
              <!-- <div v-if="scope.row.status==1">开启</div>
              <div v-else>关闭</div> -->
              </template>
            </el-table-column>
            <el-table-column
           
              label="操作"
              >
             <template slot-scope="scope">
               <el-button type="text" @click="delee(scope.row.id)"> 删除</el-button>
              </template>
            </el-table-column>
     
    </el-table>
         </div>
    </el-dialog>
  </div>
</template>

<script>
import { retailerlist,retailerlisa,login, dealerUserauthRole, updataretailer, putdealerUsera,dealerAreaOfRetailerlist,dealerAreaOfReta,delerAreaOfReta, deleretailer, dealerUserresetPwd } from "../../api/api";

export default {
  data () {
    return {
      dealerNameFull:'',
      erpform:{
        erpCode:'',
        erpCompany:'',
      },
      oldPassworda: '',
      delType: false,
      dialogVisible: false,
      erp:false,
      rolelist: [],
      doingtype: 1,
      action: 0,
      activeName: "0",
      currentPage3: 1,
      pagesize: 10,
      totale: 3,
      activeName: "first",
      mation: [], //列表
      formInline: {
        dealerName: '',
        dealerNameFull: "",
        loginEmail: "",
        loginMobile:'',
        loginPassword: "",
        parentId:'',
        status:'',
      },
      remark: '',
      titleaa: '添加账户',
      erplist:[],
    };
  },
  created () {
    this.biao();
    this.role()
  },
  computed: {

  },
  methods: {

    async login (e) {

  
      let param = {
        username:e.dealerName,
        password: e.loginPassword,
        // platform: '2',
      }
      const { data: res } = await login(param)
      if (res.code !== 200) {
        this.$message.error(res.msg)
        this.ifca = false
        return false
      }else{
        window.open("https://dms.bendamoto.com/login?token="+res.token, "_blank");
      }
     
      // http://fdms-dealer-test.bendamotor.cn/
      // sessionStorage.setItem("token", res.token)
 


    },



  async  binha(e,id){
      console.log(e,id);
      
        let param={
        id:id,
      
          status:e
       }
          
          
       const { data: res } = await dealerAreaOfReta(param)
        if(res.code==200){
          this.hacec(this.erpform.dealerId)
            }
          if (res.code !== 200) return this.$message.error(res.msg)
          console.log(res.code);
          
         
    },
    remk (e) {
      let a = this.rolelist
      console.log(e);

      a.forEach(r => {
        if (e == r.roleId) {
          this.remark = r.remark.replace('/"\n"/g,', ",")
        }
      })
      return this.remark
    },
  async  deleteU () {
 // delFlag
        // let param = this.formInline
        // // param.roleIds = [param.roleIds]
        //   param.delFlag=1
        // const { data: res } = await putdealerUsera(param)
        // if (res.code !== 200) return this.$message.error(res.msg)
        // this.$message({
        //   message: '操作成功',
        //   type: 'success'
        // });
        


      let param = new URLSearchParams();
      deleretailer(param, this.formInline.id).then(r => {
        if (r.data.code == 200) {
          this.$message.success(this.$t('menu.caozuochengong'))
          this.delType = false
        this.biao();
        } else {
          this.$message.error(r.data.msg)
          this.delType = false
        this.biao();
        }
       
      })

       
    },
    handleClose () {
      this.formInline = {
       dealerName: '',
        dealerNameFull: "",
        loginEmail: "",
        loginMobile:'',
        loginPassword: "",
        parentId:'',
        status:'',
      }
      this.oldPassworda=''
      this.dialogVisible = false

    },
    async biao () {
      let param = new URLSearchParams();

      const { data: res } = await retailerlisa(
        param,
        this.currentPage3,
        this.pagesize,
        this.dealerNameFull
      );
      console.log(res);

      this.mation = res.rows;
      this.totale = res.total;
    },

    //角色列表
    async role () {
      let param = new URLSearchParams();
      const { data: res } = await dealerUserauthRole(param);
      console.log(res);

      this.rolelist = res.roles;


    },
    //修改密码
    async updatePwd () {
      console.log(123123, this.oldPassworda);

      let param = {}
      param.loginPassword = this.oldPassworda
      param.id = this.formInline.id
      // param.password = this.formInline.password
   
      const { data: res } = await putdealerUsera(param)
      if (res.code !== 200) return this.$message.error("修改失败")
      this.$message({
        message: '修改成功',
        type: 'success'
      });
      this.handleClose()
      this.biao()


    },
    //添加账号 
    async updata () {
      if (this.titleaa == this.$t('menu.ChangePassword')) {
        this.oldpassword = ""
        this.updatePwd()
      } else {

   
     
          let param = this.formInline
        
          param.parentId = sessionStorage.getItem('userId')
         
          const { data: res } = await updataretailer(param)
          if (res.code !== 200) return this.$message.error(res.msg)
          this.$message({
            message: '添加成功',
            type: 'success'
          });
          this.handleClose()
          this.biao()
       

      }
    },
    //编辑账号 
    async putdata () {
    
        let param = this.formInline
        // param.roleIds = [param.roleIds]

        const { data: res } = await putdealerUsera(param)
        if (res.code !== 200) return this.$message.error(res.msg)
        this.$message({
          message: '添加成功',
          type: 'success'
        });
        this.handleClose()
        this.biao()
    

    },

    handleClick (tab, event) {
      console.log(tab, event);
    },
    //表单点击
   async hace(e){
      this.erplist=[]
      this.erpform={
         erpCode:'',
        erpCompany:'',
      }
    this.erpform.dealerId =e
      let param={}
       const { data: res } = await dealerAreaOfRetailerlist(param,e)
        console.log(res.rows);
          if (res.code !== 200) return this.$message.error(res.msg)
      
        this.erplist=res.rows
      this.erp=true
    },
    async delee(e){
     



       let param={}
       const { data: res } = await delerAreaOfReta(param,e)
      this.haceca(this.erpform.dealerId)
          // if (res.code !== 200) return this.$message.error(res.msg)
      
    },
    handleEdit (i, e) {
      if (i == 3) {

        this.delType = true
        this.formInline = {...e}
      } else {
        this.dialogVisible = true
        this.doingtype = i
        this.titleaa = this.$t('menu.AddAccount')
        if (i !== 1) {

          this.titleaa = this.$t('menu.Edit')
          if (i == 4) { this.titleaa = this.$t('menu.ChangePassword') }
          this.formInline = {...e}
          // this.formInline.roleIds = []
          // if (e.roles.length > 0) {
          //   this.formInline.roleIds = e.roles[0].roleId
          //   // e.roles.forEach(z => {
          //   //   this.formInline.roleIds.push(z.roleId)
          //   // });
          // }
        }
      }
    },

    //搜索
    onSubmit () {
      this.biao();
    },
   async onSuerp(){
     if(this.erpform.erpCode==''){
      this.$message({
          message: '请填写ERP编码',
          type: 'warning'
        });
      return false
     }
     if(this.erpform.erpCompany==''){
      this.$message({
          message: '请填写ERP名称',
          type: 'warning'
        });
      return false
     }
       let param={
        dealerId:this.erpform.dealerId,
        erpCode:this.erpform.erpCode,
        erpCompany:this.erpform.erpCompany,
          status:1
       }
          console.log(1111,this.erpform);
          
       const { data: res } = await dealerAreaOfReta(param)
        if(res.code==200){
          this.hacec(this.erpform.dealerId)
            }
          if (res.code !== 200) return this.$message.error(res.msg)
          console.log(res.code);
          
         
 
          
    },
  
   async hacec(e){
      this.erplist=[]
      this.erpform={
         erpCode:'',
        erpCompany:'',
      }
    this.erpform.dealerId =e
      let param={}
       const { data: res } = await dealerAreaOfRetailerlist(param,e)
      if(res.code==200){
            this.erplist=res.rows
            console.log(112323333,this.erplist);
            
        }
          if (res.code !== 200) return this.$message.error(res.msg)
     
    
    },
    async haceca(e){
     
     this.erplist=[]
    this.erpform.dealerId =e
      let param={}
       const { data: res } = await dealerAreaOfRetailerlist(param,e)
        if(res.code==200){
            this.erplist=res.rows
        }
          if (res.code !== 200) return this.$message.error(res.msg)
      
      
    
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
    this.currentPage3=val
      this.biao();
    },
  },
};
</script>

<style lang="less" scoped>
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.ccca {
  width: 400px;
}

.er {
  width: 200px;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.bonntbot {
  padding-bottom: 20px;
  border-bottom: 1px solid #d7d7d7;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

/deep/.el-table {
  min-height: 750px !important;
}

/deep/.el-form-item {
  margin-bottom: 0 !important;
}

/deep/.el-table__body td {
  padding: 20px !important;
  padding-left: 0 !important;
  text-align: left;
}

/deep/.el-form-item__label {
  text-align: left !important;
}

/deep/.el-table th.is-leaf {
  text-align: left;
  // background-color: #d7d7d7;
}

/deep/.el-tabs {
  height: 97%;
  width: 100%;
}

/deep/.el-tabs__content {
  width: 100%;
  height: 100%;
}

/deep/.el-table--scrollable-x .el-table__body-wrapper {
  height: 90%;
}

/deep/.el-tab-pane {
  height: 82%;
}

/deep/.el-table--fit {
  height: 94%;
}

.xz-box {
  width: 400px;
  margin: 0 auto;
}

.actio {
  color: #409eff;
}

/deep/.el-form-item__content {
  margin-left: 0 !important;
}
</style>